<template>
    <div class='order'>
        <!-- <h3 class="order_border">您的訂單編號為: <strong style="color: #f30d2a;">{{ this.$route.params.id }}</strong></h3> -->
        <div v-for="item in order">
            <div class="order_detail">
                <!-- <div class="text">訂單資訊</div> -->
                <div class="content">
                    <div class="item">
                        <div class="item_title">訂單編號</div>
                        <div class="item_contnet">{{ item.order.order_num }}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">建立時間</div>
                        <div class="item_contnet">{{ item.order.created_at }}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">付款方式為</div>
                        <div class="item_contnet">{{ selectpayment.pay_name }}</div>
                    </div>
                    <div class="item" style="width: 50%; margin: auto;"
                        v-if="selectpayment.mode !== 'ReceivedPay' && item.payment.status !== 'success' && selectpayment.mode !== 'ReceivedPay711' && selectpayment.st !== 'checking'">
                        <!-- <div class="item_title">前往付款</div> -->
                        <div class="item_contnet">
                            <div class="unpaid">
                                <div v-if="selectpayment.data_list == -1" style="color: #F30d2a; font-size: 20px;">
                                    付款失敗請聯絡客服
                                </div>
                                <form v-else :action="selectpayment.furl" :method="selectpayment.fmethod" class="form">
                                    <button type="submit" class="btn">前往付款</button>
                                    <div class="img">
                                        <img src="@/assets/finger.gif" alt="">
                                    </div>
                                    <div v-for="(value, key) in selectpayment.data_list" :key="key">
                                        <input type="hidden" :name="key" :value="value">
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="item" v-if="selectpayment.st === 'checking'">
                        <div class="item_title" style="width: 100%;">請轉帳到該銀行：</div>
                    </div>
                    <div class="item" v-if="selectpayment.st === 'checking'">
                        <div class="item_title">銀行代號</div>
                        <div class="item_contnet">{{ selectpayment.bk_code }}</div>
                    </div>
                    <div class="item" v-if="selectpayment.st === 'checking'">
                        <div class="item_title">銀行帳號</div>
                        <div class="item_contnet">{{ selectpayment.bk_acc }}</div>
                    </div>
                    <!-- <div class="item">
                        <div class="item_title">聯絡電話</div>
                        <div class="item_contnet">{{ item.receiver.phone }}</div>
                    </div> -->
                </div>
            </div>
            <!-- <el-row class="order_border" :gutter="30">
                <el-col :sm="16" :md="18">
                    <h4>您選擇的付款方式為:<strong>{{ selectpayment.pay_name }}</strong></h4>
                    <p v-if="selectpayment.pay_name !== '貨到付款'">點擊確認付款，將前往付款中心進行付款操作，期間請勿按『返回』或是『重新整理』，否則可能造成付款失敗。</p>
                    <div v-if="selectpayment.st === 'checking'">
                        <h4>請轉帳到該銀行：</h4>
                        <h4>銀行代號：<span style="font-weight: bold;">{{ selectpayment.bk_code }}</span></h4>
                        <h4>銀行帳號: <span style="font-weight: bold;">{{ selectpayment.bk_acc }}</span></h4>
                    </div>
                </el-col>
                <el-col :sm="8" :md="6">
                    <div class="unpaid"
                        v-if="selectpayment.mode !== 'ReceivedPay' && item.payment.status !== 'success' && selectpayment.mode !== 'ReceivedPay711' && selectpayment.st !== 'checking'">

                        <div v-if="selectpayment.data_list == -1" style="color: #F30d2a; font-size: 20px;">付款失敗請聯絡客服</div>
                        <form v-else :action="selectpayment.furl" :method="selectpayment.fmethod" class="form">
                            <button type="submit" class="btn">前往付款</button>
                            <div class="img">
                                <img src="@/assets/finger.gif" alt="">
                            </div>
                            <div v-for="(value, key) in selectpayment.data_list" :key="key">
                                <input type="hidden" :name="key" :value="value">
                            </div>
                        </form>
                    </div>
                </el-col>
            </el-row> -->

            <h3>您購買的商品是：</h3>
            <ul class="cl-ul">
                <li class="shoplist_item hidden_xs">
                    <div class="item cell1">
                        <span>商品</span>
                    </div>
                    <div class="item cell2">
                        <div class="row">
                            <div class="w33">
                                <span style="text-align:left">單價</span>
                            </div>
                            <div class="w33">
                                <span>數量</span>
                            </div>
                            <div class="w33">
                                <span style="text-align:right">小計</span>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="shoplist_item" v-for="items in item.item.slice(0, -1)">
                    <div class="item cell1">
                        <div class="thumb">
                            <img :src="items.display_img_small" :alt="items.form_name">
                        </div>
                        <div class="name">
                            <div class="item_name">
                                <a href="javascript:;" class="cl-a">
                                    {{ items.form_name }}
                                </a>
                                <div class="line-item-note" v-for="sub in items.sub">
                                    <span v-if="sub.num !== 0">
                                        <span v-if="sub.sub_type == 'SFREE'" style="color: #dc3545;">- 贈品-{{
            sub.form_name }}*{{ sub.num }}</span>
                                        <span v-else>- {{ sub.form_name }}*{{ sub.num }}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item cell2">
                        <div class="row">
                            <div class="w33">
                                <div class="padd_top">
                                    <span class="visible_xs">單價 </span>
                                    <span style="text-align:left;font-weight: initial;">${{ items.price }}</span>
                                </div>
                            </div>
                            <div class="w33">
                                <div class="padd_top">
                                    <span class="visible_xs">數量</span>
                                    <span class="test">{{ items.num }}</span>
                                </div>
                            </div>
                            <div class="w33">
                                <div class="padd_top">
                                    <span class="visible_xs">小計 </span>
                                    <span style="text-align:right;font-weight: initial;">${{ items.total }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="total">
                <div class="total_content">
                    <el-row :gutter="30">
                        <el-col :xs="12" :sm="18" :md="20">
                            <div class="grid-content bg-purple">商品小計</div>
                        </el-col>
                        <el-col :xs="6" :sm="4" :md="4">
                            <div class="grid-content bg-purple-light">+{{ total | formatNumberToqff }}</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30">
                        <el-col :xs="12" :sm="18" :md="20">
                            <div class="grid-content bg-purple">運費</div>
                        </el-col>
                        <el-col :xs="6" :sm="4" :md="4">
                            <div class="grid-content bg-purple-light">+{{ order_freight | formatNumberToqff }}</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="30">
                        <el-col :xs="12" :sm="18" :md="20">
                            <div class="grid-content bg-purple">總計</div>
                        </el-col>
                        <el-col :xs="6" :sm="4" :md="4">
                            <div class="grid-content bg-purple-light" style="font-size:18px;color:#F30d2a">${{
            item.total }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <h2>
                <i class="el-icon-present"></i>
                謝謝您，我們已經成功接收了您的訂單。
            </h2>
            <!-- <div class="alert">
            <p style="margin:0">訂單資訊已發送到您的信箱，內容包含此頁面地址，如付款過程出現問題，請打開此連結地址重新付款，或是前往『訂單查詢』頁面確認與查詢。</p>
            <p style="margin:5px 0 0">若您選擇線上付款，請點擊上方付款前往付款中心進行付款操作！</p>
        </div> -->
            <div class="order_info">
                <div class="order_fulfillment_timeline ">
                    <div class="time show" :class="stepActive == 1 ? 'active' : ''">
                        <div class="point " data-status="尚未處理"></div>
                        <div class="mobile_setp">
                            <div>尚未處理</div>
                            <!-- <div>2023-10-31 17:19</div> -->
                        </div>
                    </div>
                    <div class="time" :class="stepActive == 2 ? 'show active' : stepActive > 2 ? 'show' : ''">
                        <div class="point " data-status="倉庫理貨" data-time=""></div>
                        <div class="mobile_setp">
                            <div>倉庫理貨</div>
                            <div></div>
                        </div>
                        <hr>
                    </div>
                    <div class="time" :class="stepActive == 3 ? 'show active' : stepActive > 2 ? 'show' : ''">
                        <div class="point " data-status="物流配送" data-time=""></div>
                        <div class="mobile_setp">
                            <div>物流配送</div>
                            <div></div>
                        </div>
                        <hr>
                    </div>
                    <div class="time" :class="stepActive == 4 ? 'show active' : ''">
                        <div class="point " data-status="完成" data-time=""></div>
                        <div class="mobile_setp">
                            <div>完成</div>
                            <div></div>
                        </div>
                        <hr>
                    </div>
                </div>
                <div class="order_detail">
                    <div class="text">付款資訊</div>
                    <div class="content">
                        <div class="item">
                            <div class="item_title">付款狀態</div>
                            <div class="item_contnet">{{ item.payment.status_name }}</div>
                        </div>
                        <div class="item">
                            <div class="item_title">付款方式</div>
                            <div class="item_contnet">{{ selectpayment.pay_name }}</div>
                        </div>
                    </div>
                </div>
                <div class="order_detail">
                    <div class="text">收件資訊</div>
                    <div class="content">
                        <div class="item">
                            <div class="item_title">收件人</div>
                            <div class="item_contnet">{{ item.receiver.name }}</div>
                        </div>
                        <div class="item">
                            <div class="item_title">收件地址</div>
                            <div class="item_contnet">{{ item.receiver.address }}</div>
                        </div>
                        <div class="item">
                            <div class="item_title">聯絡電話</div>
                            <div class="item_contnet">{{ item.receiver.phone }}</div>
                        </div>
                    </div>
                </div>
                <div class="order_detail">
                    <div class="text">配送資訊</div>
                    <div class="content">
                        <div class="item">
                            <div class="item_title">配送狀態</div>
                            <div class="item_contnet">{{ item.logistics.status_name }}</div>
                        </div>
                        <!-- <div class="item">
                        <div class="item_title">配送方式</div>
                        <div class="item_contnet">宅配</div>
                    </div> -->
                        <div class="item">
                            <div class="item_title">指定配送日期</div>
                            <div class="item_contnet">依實際出貨日期為準</div>
                        </div>
                    </div>
                </div>
                <div class="order_detail">
                    <div class="text">訂單備註</div>
                    <div class="content">
                        <div class="item">
                            <div class="item_contnet">{{ item.receiver.note }}</div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <Navbar></Navbar>
    </div>
</template>

<script>
import Navbar from '@/components/navbar/index.vue'
import Vue from 'vue';
import numeral from "numeral";
import { mapState } from 'vuex'
import {
    Row,
    Col,
} from 'element-ui';
Vue.use(Row);
Vue.use(Col);
import GA4EventApi from '@/js/GA4EventApi';
export default {
    components: { Navbar },
    data() {
        return {
            total: 0,
            order_freight: 0,
            stepActive: 1,
            order_result: false,
        };
    },
    computed: {
        ...mapState('order', ['payment_method', 'selectpayment', 'order']),
        ...mapState('cart', ['number', 'cart_list_item', 'freight', 'cart_list'])
    },
    watch: {

    },
    methods: {
        call_back() {
            this.$store.dispatch('order/payment_one', this.$route.params.id).then((e) => {
                if (e.st === "checking") {
                    // 如果状态为 "checking"，等待 10 秒后再次请求
                    setTimeout(() => {
                        this.call_back();
                    }, 10000); // 10 秒
                } else if (e.st === "success") {
                    this.$store.dispatch('order/payment_two', { data: this.$route.params.id }).then((e) => {
                        // console.log(e);
                        if (e) {
                            this.total = 0;
                            let item = this.$store.getters['order/order']
                            item[0].item.forEach((e) => {
                                if (e.type !== 'SYS') {

                                    this.total += e.total.replace(/,/g, "") * 1
                                }
                            })
                            this.order_freight = item[0].total.replace(/,/g, "") * 1 - this.total;
                            if (this.order[0]) {
                                // 统计对象中true的数量
                                const trueCount = Object.values(this.order[0].progress.status).reduce((count, value) => count + (value === true), 0);
                                // 计算step的值，并确保它在1到4之间
                                this.stepActive = Math.min(Math.max(1, trueCount), 4);

                            }
                        }
                    });
                } else {
                    // 状态不是 "checking"，结束循环
                    // 在这里处理不是 "checking" 的状态
                    console.log('状态已改变，停止循环');
                }
                // console.log(1);
            }).catch(error => {
                // 处理错误
                console.error('An error occurred:', error);
            });
        },
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    created() {
    },
    mounted() {
        this.$store.dispatch('order/payment_one', this.$route.params.id).then((e) => {
            setTimeout(() => {
                this.call_back();
            }, 10000); // 10 秒
        });
        this.$store.dispatch('order/payment_two', { data: this.$route.params.id }).then((e) => {
            if (e) {
                // console.log(e,'e');
                let item = this.$store.getters['order/order']
                // console.log(item,'item');
                // var GAFourEventApi = new GA4EventApi();
                // GAFourEventApi.purchase(item[0]);
                item[0].item.forEach((e) => {
                    if (e.type !== 'SYS') {

                        this.total += e.total.replace(/,/g, "") * 1
                    }
                })
                this.order_freight = item[0].total.replace(/,/g, "") * 1 - this.total;
                if (this.order[0]) {
                    // 统计对象中true的数量
                    const trueCount = Object.values(this.order[0].progress.status).reduce((count, value) => count + (value === true), 0);
                    // 计算step的值，并确保它在1到4之间
                    this.stepActive = Math.min(Math.max(1, trueCount), 4);

                }
            }
        });
    },
}
</script>

<style src="./index.scss" lang='scss' scoped></style>